module.exports = __webpack_public_path__ + "24e717a05902ec3db56e840da1a2e68c.png";